'use strict';

var React = require('react');

var SvgTextAlignmentCenterMajor = function SvgTextAlignmentCenterMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3 3h14a1 1 0 1 1 0 2h-14a1 1 0 0 1 0-2zm2 4h10a1 1 0 1 1 0 2h-10a1 1 0 0 1 0-2zm-2 4h14a1 1 0 0 1 0 2h-14a1 1 0 0 1 0-2zm2 4h10a1 1 0 0 1 0 2h-10a1 1 0 0 1 0-2z"
  }));
};

exports.SvgTextAlignmentCenterMajor = SvgTextAlignmentCenterMajor;
